import React, { FunctionComponent, useEffect, useState } from 'react'
// Disabling because getSize is required for component
// eslint-disable-next-line no-restricted-imports
import { Image as RNImage, View } from 'react-native'

import { ASSETS_CDN_URL } from '../../constants'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

export type CalendarAvailableIllustrationProps = {
  width?: number | string
}

export const CalendarAvailableIllustration: FunctionComponent<CalendarAvailableIllustrationProps> = ({
  width = 50,
  ...props
}) => {
  const uri = `${ASSETS_CDN_URL}calendarAvailabilityIllustrationNoBackground.png`
  const [aspectRatio, setAspectRatio] = useState(1)

  // Convert width to number for calculations
  const numericWidth = typeof width === 'number' ? width : parseInt(width.toString())

  useEffect(() => {
    RNImage.getSize(
      uri,
      (imageWidth: number, imageHeight: number) => {
        setAspectRatio(imageWidth / imageHeight)
      },
      (error) => {
        console.error('Failed to get image size for calendarAvailabilityIllustration: ', error)
      },
    )
  }, [uri])

  return (
    <View
      style={{
        width: numericWidth,
        height: numericWidth,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
      }}
      testID={tID('CalendarAvailableIllustration')}
    >
      <Image
        source={{ uri }}
        style={{
          width: numericWidth,
          height: undefined,
          aspectRatio,
          backgroundColor: 'transparent',
        }}
        alt='Calendar available illustration'
        contentFit='contain'
        {...props}
      />
    </View>
  )
}
